import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  style: {"margin-top":"16px","text-align":"right"}
}
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelecionarCstIbs = _resolveComponent("SelecionarCstIbs")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_SelecionarClassificacaoIbs = _resolveComponent("SelecionarClassificacaoIbs")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16, 16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Parâmetros IBS/CBS",
            bordered: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, { layout: "vertical" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "Situação Tributária (CST)" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelecionarCstIbs, {
                        cstSelecionado: _ctx.form.cst,
                        "onUpdate:cstSelecionado": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.cst) = $event))
                      }, null, 8, ["cstSelecionado"])
                    ]),
                    _: 1
                  }),
                  (_ctx.form.cst)
                    ? (_openBlock(), _createBlock(_component_a_form_item, {
                        key: 0,
                        label: "Classificação Detalhada (Natureza)"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SelecionarClassificacaoIbs, {
                            classificacaoSelecionada: _ctx.form.classificacao,
                            "onUpdate:classificacaoSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.classificacao) = $event)),
                            "cst-selecionado": _ctx.form.cst?.codigo,
                            disabled: !_ctx.form.cst
                          }, null, 8, ["classificacaoSelecionada", "cst-selecionado", "disabled"]),
                          (!_ctx.form.cst)
                            ? (_openBlock(), _createBlock(_component_a_typography_text, {
                                key: 0,
                                type: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Selecione um CST para ver as classificações. ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        xs: 24,
        md: 12
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, {
            direction: "vertical",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              (_ctx.form.cst)
                ? (_openBlock(), _createBlock(_component_a_card, {
                    key: 0,
                    title: `Regras do CST ${_ctx.form.cst.codigoCst}`,
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_descriptions, {
                        bordered: "",
                        column: 2,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_descriptions_item, { label: "Tributação Normal" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tag, {
                                color: _ctx.form.cst.indGCbsIbs ? 'green' : 'default'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.form.cst.indGCbsIbs ? 'Sim' : 'Não'), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_descriptions_item, { label: "Monofásico" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tag, {
                                color: _ctx.form.cst.indGCbsIbsMono ? 'purple' : 'default'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.form.cst.indGCbsIbsMono ? 'Sim' : 'Não'), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_descriptions_item, { label: "Redução Alíquota" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tag, {
                                color: _ctx.form.cst.indGCbsIbsRed ? 'blue' : 'default'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.form.cst.indGCbsIbsRed ? 'Sim' : 'Não'), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_descriptions_item, { label: "Diferimento" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tag, {
                                color: _ctx.form.cst.indGCbsIbsDif ? 'orange' : 'default'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.form.cst.indGCbsIbsDif ? 'Sim' : 'Não'), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.form.classificacao)
                ? (_openBlock(), _createBlock(_component_a_card, {
                    key: 1,
                    title: "Impacto na Nota Fiscal",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, {
                        gutter: 16,
                        style: {"text-align":"center","margin-bottom":"16px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_statistic, {
                                title: "Redução IBS",
                                value: _ctx.form.classificacao.pRedIbs,
                                suffix: "%"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_statistic, {
                                title: "Redução CBS",
                                value: _ctx.form.classificacao.pRedCbs,
                                suffix: "%"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions, {
                        bordered: "",
                        column: 1,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_descriptions_item, { label: "NF-e (Mod 55)" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tag, {
                                color: _ctx.form.classificacao.indNfe ? 'green' : 'red'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.form.classificacao.indNfe ? 'Permitido' : 'Bloqueado'), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_descriptions_item, { label: "NFC-e (Mod 65 - Varejo)" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_tag, {
                                color: _ctx.form.classificacao.indNfce ? 'green' : 'red'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.form.classificacao.indNfce ? 'Permitido' : 'Bloqueado'), 1)
                                ]),
                                _: 1
                              }, 8, ["color"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_ctx.form.classificacao.indNfce)
                        ? (_openBlock(), _createBlock(_component_a_alert, {
                            key: 0,
                            message: "Atenção: Esta classificação não pode ser vendida no caixa (PDV).",
                            type: "warning",
                            "show-icon": "",
                            style: {"margin-top":"16px"}
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.form.classificacao)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(_component_a_typography_text, { type: "secondary" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Fundamento: "),
                                _createElementVNode("a", {
                                  href: _ctx.form.classificacao.link,
                                  target: "_blank"
                                }, _toDisplayString(_ctx.form.classificacao.link), 9, _hoisted_2)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}